<template>
    <div>
        <div style="float:left;color:white">
            {{projectName}}
        </div>
        <div class="topBar">
            <account></account>

            <div style="float:left;display: flex;width: 60px;;cursor: pointer" @click="toUserMessage()" title="站内信">
                <i class="el-icon-message" style="line-height: 50px;font-size: 30px; color: white"></i>
                <div style="color:white;line-height: 25px;font-size: 14px;display: flex;flex-direction:column-reverse;">
                    {{smsCount}}
                </div>
            </div>
            <div style="float:left;color:white;width: 30px;">
                |
            </div>

            <div style="float:left;display: flex;width: 60px;cursor: pointer" @click="toTaskList()" title="待办任务">
                <i class="el-icon-document-checked" style="line-height: 50px;font-size: 30px; color: white"></i>
                <div style="color:white;line-height: 25px;font-size: 14px;display: flex;flex-direction:column-reverse;">
                    {{taskCount}}
                </div>
            </div>
            <div style="float:left;color:white;width: 30px;">
                |
            </div>

            <div style="float:left;display: flex;width: 60px;">
                <i class="el-icon-thumb" style="line-height: 50px;font-size: 30px; color: white"></i>
            </div>
            <div style="float:left;color:white;width: 30px;">
                |
            </div>

            <div style="float:left;display: flex;width: 60px;">
                <i class="el-icon-umbrella" style="line-height: 50px;font-size: 30px; color: white"></i>
            </div>
            <div style="float:left;color:white;width: 30px;">
                |
            </div>

            <div style="float:right;width: 120px;height: 50px;">
                <el-popover
                        placement="bottom-start"
                        width="60"
                        trigger="hover">
                    <div class="hoverFlag">
                        <div class="sysTag"  @click="toChangePassword()">
                            <i class="el-icon-s-tools" style="color:red;"></i>
                            修改密码
                        </div>
                        <el-divider></el-divider>
                        <div class="sysTag" @click="loginOut">
                            <i class="el-icon-monitor" style="color:red"></i>
                            退出登录
                        </div>
                    </div>
                    <div slot="reference" style="height: 50px;display: flex;align-items:center;">
                        <img style="border-radius: 100%;border: 2px solid #FFF;"
                             src="@/assets/home/users.png"
                             alt="系统管理员">
                        <div style="margin-left:10px">
                            <div style="text-align:center;line-height: 15px;color:white;font-size: 14px">欢迎您</div>
                            <div style="line-height: 15px;color:white;font-size: 14px">{{userInfo.userName}}</div>
                        </div>
                    </div>
                </el-popover>
            </div>
        </div>
    </div>
</template>

<script>
    import account from './navTop/account'
    /*import monthaccount from './navTop/monthaccount'*/

    export default {
        name: "navTop",
        components:{
            account
        },
        data() {
            return {
                smsCount:"",
                taskCount:"",
                projectName: window.host.projectName,
                userInfo: {
                    userName:""
                },
                loginInfo:this.$store.state.loginInfo
            }
        },
        async mounted() {
            this.userInfo = this.loginInfo.user;
            await this.getMsgCount();
            await this.getTaskCount();
        },
        watch: {
            loginInfo: {
                handler(val) {
                    if(val){
                        this.accountList = this.loginInfo.accountList;
                        this.userInfo = this.loginInfo.user;
                    }
                },
                deep: true
            },
        },
        methods: {
            async getMsgCount(){
                let param = {
                    url: "/head/getInfo",
                    param: {}
                }
                const data = await this.$store.dispatch('pubMethod', param)
                if (data.infoCode == "0") {
                    this.smsCount = data.data.smsCount;
                }
            },
            async getTaskCount(){
                let param = {
                    url: "/rutask/getList",
                    param: {}
                }
                const data = await this.$store.dispatch('pubMethod', param)
                if (data.infoCode == "0") {
                    this.taskCount = data.data.taskCount;
                }
            },
            loginOut(){
                this.$confirm('即将退出该系统, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.$router.push({path: '/login'})
                });
            },
            clickMsg(){
                this.$emit('clickMsg');
            },
            refreshWork(){
                this.$emit('refreshWork');
            },
            toUserMessage(){
                this.$emit('clickMsg');
            },
            toTaskList(){
                this.$emit('clickTask');
            }
            ,toChangePassword(){
                this.$emit('changePassword');
            }
        },
    }
</script>


<style scoped lang="scss">
    .el-popover--plain {
        padding: 0px;
    }

    .topBar {
        float: right;
        width: 560px;
        height: 50px;
    }

    .hoverFlag {
        .el-divider--horizontal {
            margin: 5px 0;
        }

        border: 1px solid #1ba9ff;
        -moz-box-shadow: 10px 10px 5px #888888;
        box-shadow: 10px 10px 5px #888888;
    }

    .sysTag {
        cursor: pointer;
        padding: 5px 15px;
        overflow: hidden;
        transition: all 1s linear;
    }

    .topTag {
        /*color: #fff;*/
        cursor: pointer;
        border: none;
        padding: 5px 15px;
        overflow: hidden;
        transition: all 1s linear;
        border-bottom: 1px solid #B3C0D1;
    }

    .topSelTag {
        color: #fff;
        border: none;
        padding: 5px 15px;
        overflow: hidden;
        transition: all 1s linear;
        border-bottom: 1px solid #3F3F3F;
        background: linear-gradient(to right bottom, #3091f2 50%, #5cadff 0);
    }

    .topSelTag:hover, .topTag:hover {
        color: #fff;
        background: linear-gradient(to right bottom, #3091f2 50%, #5cadff 0);
        transform: scale(1.1);
        animation: toBig 1s ease-in-out 1;
        -webkit-animation: toBig 1s ease-in-out 1;
        box-shadow: 0 1px 2px rgba(0, 0, 0, .2);
    }

    .sysTag:hover {
        color: #fff;
        background: linear-gradient(to right bottom, #eaba0c 50%, #eaba0c 0);
        transform: scale(1.1);
        animation: toBig 1s ease-in-out 1;
        -webkit-animation: toBig 1s ease-in-out 1;
        box-shadow: 0 1px 2px rgba(0, 0, 0, .2);
    }

    @keyframes toBig { /*定义关键帧、scaleDrew是需要绑定到选择器的关键帧名称*/
        0% {
            transform: scale(1); /*开始为原始大小*/
        }
        100% {
            transform: scale(1.1);
        }
    }
</style>
